<template>
  <el-checkbox :indeterminate="isIndeterminate" :disabled="disabled" v-model="checkValue" @change="change">{{text}}</el-checkbox>
</template>
<script>
  export default {
    props: {
      value: {
        type:[Number, String],
        default: -1
      },
      disabled: {
        type: Boolean,
        default: false
      },
      three: {
        type: Boolean,
        default: true,
      },
      text: {
        type: String,
        default: ''
      }
    },
    mounted() {
      this.init();
    },
    data() {
      return {
        isIndeterminate: false,
        checkValue: false,
      };
    },
    methods: {
      init() {
        if (this.value == -1) {
          //  
          this.checkValue = false;
          this.isIndeterminate = false;
        } else if (this.value == 0) { 
          // X
          this.checkValue = false;
          this.isIndeterminate = true;
        } else if (this.value > 0) {
          // v
          this.checkValue = true;
          this.isIndeterminate = false;
        }
      },
      change(val) {
        if (this.three) {
          if (this.value == -1) {
            let res = this.value > 0 ? this.value : 1;
            this.$emit("input", res);
          } else if (this.value == 0) { 
            this.$emit("input", -1);
          } else if (this.value > 0) {
            this.$emit("input", 0);
          }
        } else {
          if ([-1,0].includes(this.value)) {
            let res = this.value > 0 ? this.value : 1;
            this.$emit("input", res);
          } else{ 
            this.$emit("input", 0);
          }
        }
        this.$emit('change',val)
      }
    },
    watch: {
      value() {
        this.init();
      }
    }
  };
</script>
<style lang="less" scoped>
  /deep/.el-checkbox {
    width: 14px;
    .el-checkbox__input.is-indeterminate {
      .el-checkbox__inner {
        border-color: #F33;
        background-color:#F33;
        &::before {
          content: "✕";
          position: absolute;
          display: block;
          background-color: #fff;
          height: 0px;
          transform: scale(0.5);
          left: -2px;
          right: 0;
          font-size: 21px;
          top: 1px;
          color: #fff;
        }
      }
    }
  }
</style>